import React from 'react';
import { useTranslation } from 'react-i18next';
import i18n from '../../../i18n/i18n';

const DeleteConfirmModal = ({ isOpen, onClose, onConfirm, accountName, translationKeyPrefix = 'accountsTree' }) => {
  const { t } = useTranslation('global');
  const isRTL = i18n.language === 'ar';
  const textAlign = isRTL ? 'right' : 'left';
  const dir = isRTL ? 'rtl' : 'ltr';
  
  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      background: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 999999
    }} onClick={onClose}>
      <div style={{
        background: '#1f2937',
        padding: '2rem',
        borderRadius: '12px',
        width: '90%',
        maxWidth: '400px',
        position: 'relative',
        direction: dir
      }} onClick={(e) => e.stopPropagation()}>
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '1rem',
            [isRTL ? 'left' : 'right']: '1rem',
            background: 'transparent',
            border: 'none',
            color: '#9ca3af',
            cursor: 'pointer',
            fontSize: '24px',
            width: '32px',
            height: '32px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '8px',
            transition: 'all 0.2s'
          }}
          onMouseEnter={(e) => {
            e.target.style.background = '#374151';
            e.target.style.color = '#fff';
          }}
          onMouseLeave={(e) => {
            e.target.style.background = 'transparent';
            e.target.style.color = '#9ca3af';
          }}
        >
          ×
        </button>

        <div style={{ textAlign: 'center', marginTop: '1rem' }}>
          <div style={{
            width: '60px',
            height: '60px',
            margin: '0 auto 1.5rem',
            borderRadius: '50%',
            background: 'rgba(239, 68, 68, 0.1)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <span style={{ fontSize: '32px', color: '#ef4444' }}>⚠️</span>
          </div>
          
          <h3 style={{ color: '#fff', marginBottom: '0.5rem', fontSize: '18px', fontWeight: 600, textAlign }}>
            {t(`${translationKeyPrefix}.deleteModal.title`)}
          </h3>
          
          <p style={{ color: '#9ca3af', marginBottom: '1.5rem', fontSize: '14px', lineHeight: '1.5', textAlign }}>
            {t(`${translationKeyPrefix}.deleteModal.message`)}
          </p>
          
          {accountName && (
            <p style={{ color: '#fff', marginBottom: '1.5rem', fontSize: '16px', fontWeight: 600, textAlign, direction: isRTL ? 'rtl' : 'ltr' }}>
              {accountName}
            </p>
          )}
          
          <p style={{ color: '#ef4444', marginBottom: '1.5rem', fontSize: '13px', textAlign }}>
            {t(`${translationKeyPrefix}.deleteModal.warning`)}
          </p>
        </div>

        <div style={{ display: 'flex', gap: '0.75rem', marginTop: '1.5rem', flexDirection: isRTL ? 'row-reverse' : 'row' }}>
          <button
            onClick={onClose}
            style={{
              flex: 1,
              padding: '0.75rem',
              background: '#374151',
              border: '1px solid #4b5563',
              borderRadius: '8px',
              color: '#fff',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: 600,
              transition: 'all 0.2s',
              textAlign
            }}
            onMouseEnter={(e) => {
              e.target.style.background = '#4b5563';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = '#374151';
            }}
          >
            {t(`${translationKeyPrefix}.deleteModal.cancel`)}
          </button>
          <button
            onClick={onConfirm}
            style={{
              flex: 1,
              padding: '0.75rem',
              background: '#ef4444',
              border: 'none',
              borderRadius: '8px',
              color: '#fff',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: 600,
              transition: 'all 0.2s',
              boxShadow: '0 2px 4px rgba(239, 68, 68, 0.2)',
              textAlign
            }}
            onMouseEnter={(e) => {
              e.target.style.background = '#dc2626';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = '#ef4444';
            }}
          >
            {t(`${translationKeyPrefix}.deleteModal.delete`)}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;


